import * as PropTypes from 'prop-types';
import * as React from 'react';
import { compact, without } from 'lodash';
import Pill from './pill';

const FileTypeSearchPills = ({ fileTypes, changeFileTypes, fileType }) => {
  if (!fileTypes) { return false; }

  const traitValues = compact(fileTypes.map((slug) => {
    const otherFileTypes = without(fileTypes, slug);
    const traitValue = fileType.findValueBySlug(slug);
    if (traitValue) {
      return (
        <Pill
          key={traitValue.name}
          value={traitValue.name}
          onClick={() => changeFileTypes(otherFileTypes)}
        />
      );
    }

    return null;
  }));

  return <span>{traitValues}</span>;
};

FileTypeSearchPills.propTypes = {
  fileTypes: PropTypes.array,
  fileType: PropTypes.object.isRequired,
  changeFileTypes: PropTypes.func.isRequired,
};

export default FileTypeSearchPills;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/file_type_search_pills.jsx